/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
var lazyInstance;
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    custom_select: function (selector, click_callback)
    {
      var slide_callback = function (item, show) {
        var button_icon = $(item).find('.filter i.fa');
        if (show) {
          button_icon.removeClass('fa-plus-thin').addClass('fa-minus-thin');
        }
        else {
          button_icon.removeClass('fa-minus-thin').addClass('fa-plus-thin');
        }
      };

      $("#switch-" + selector).on('click', function (e) {
        e.stopPropagation();
        $('[class$="-switch-list"]').slideUp();
        $('[class$="-switch-button"] .filter i.fa').removeClass('fa-minus-thin').addClass('fa-plus-thin');
        if ($('div#' + selector + '-switch-list').is(':visible')) {
          $('div#' + selector + '-switch-list').slideUp(400, slide_callback(this, false));
        }
        else {
          $('div#' + selector + '-switch-list').slideDown(400, slide_callback(this, true));
        }
      });
      $('body').click(function (e) {
        var target = $(e.target);
        if (!target.is('div#' + selector + '-switch-list')) {
          if ($('div#' + selector + '-switch-list').is(':visible')) {
            $('div#' + selector + '-switch-list').slideUp(400, slide_callback(this, false));
          }
        }
      });
      $('#' + selector + '-switch-list ul li a').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass('disabled')) {
          return;
        }
        $('#' + selector + '-switch-list ul li a').show();
        $(this).hide();
        click_callback($(this));
        $('div#' + selector + '-switch-list').slideUp(400, slide_callback($(this).parents('.feature-value-switch'), false));
      });
    },

    update_index_search: function (top_param)
    {
      if ($('body#index').length) {
        var top = 'undefined' != typeof (top_param) ? top_param : $(window).scrollTop();

        var splash = $('#slide-holder');
        var splash_heigth = splash.height();

        var splash_position = splash.position(),
          class_name = 'index',
          header_height = $('.fixed-header-index-wrapper').height();
//        if (top + header_height * 2 >= (splash_position.top + splash_heigth)) {
      }
    },

    update_cart_height: function (top_param)
    {
      var difference = $(window).height() - 300;
      difference = (difference > 365 ? 365 : (difference < 100 ? 100 : difference));

      $('.ajax-cart-top').find('.cart-content').css('max-height', difference);
    },

    product_block_height: function ()
    {
      var start_index = 0;
      var end_index = 4;
      var count_of_products_per_line = 4;
      if ($(window).width() < 768) {
        end_index = 2;
        count_of_products_per_line = 2;
      }
      $('.products-container').each(function (i, e) {
        while (end_index < $('.products-container .ajax_block_product').length) {
          var current_part = $('.products-container .ajax_block_product').slice(start_index, end_index);
          $(current_part).find('.product-link').height('auto');
          $(current_part).find('.product-link').equalHeights();
          if ($(current_part).find('.atdevshowattribute-wrapper').length) {
            $(current_part).find('.atdevshowattribute-wrapper').height('auto');
            $(current_part).find('.atdevshowattribute-wrapper').equalHeights();
          }
          start_index += count_of_products_per_line;
          end_index += count_of_products_per_line;
        }
      });
    },

    update_wishlist_buttons: function ()
    {
      if (typeof wishListProductsIds == 'object') {
        $.each(wishListProductsIds, function (i, v) {
          $('#wlAddBtn'+i).addClass('in-wishlist');
        });
      }
    },

    lazy_init: function ()
    {
      lazyInstance = $('.lazy').Lazy({
        chainable: false,
        visibleOnly: true,
        afterLoad: function(element) {
          if (typeof(bestsellerIso) !== 'undefined') {
            bestsellerIso.arrange();
          }
          element.removeClass('lazy');
          Sage.product_block_height();

          if (element.hasClass('ios-refresh')) {
            var $parent = element.parent();
            $('body').append(element);
            $parent.append(element)
          }
        }
      });
    },

    lazyInitComponent: function ($containers, func)
    {
      var inited = false;
      var $container = $containers.first(), $window = $(window);

      var check = function() {
        return $container.size() && $window.scrollTop() + $window.height() > $container.offset().top;
      }

      if (check()) {
        inited = true;
        func();
      }

      $window.scroll(function () {
        if (!inited && check()) {
          inited = true;
          func();
        }
      })
    },

    'authentication_page': {
        validationErrors: [],
        init: function () {
          var self = this;
          this.frontValidation();

          $('#account-creation_form').on('submit', function () {
            if (self.validationErrors.length) {
                $('html, body').animate({
                    scrollTop: $(self.validationErrors[0]).offset().top - 200
                }, 1000);
              return false;
            }
          })
        },
        frontValidation: function () {
            var self = this;
            // Italy custom validation
            $(document).ready(function() {
                $('#phone, #id_country, #phone_mobile').on('change', function(){
                    var phoneValidateRegexp = /^0039/;
                    if ($('#id_country').val() == 10 && $('#phone').val() != '') {
                        if (phoneValidateRegexp.exec($('#phone').val())) {
                            self.setFieldValid('#phone');
                        } else {
                            self.setFieldUnvalid('#phone');
                        }
                    }

                    if ($('#id_country').val() == 10 && $('#phone_mobile').val() != '') {
                        if (phoneValidateRegexp.exec($('#phone_mobile').val())) {
                            self.setFieldValid('#phone_mobile');
                        } else {
                            self.setFieldUnvalid('#phone_mobile');
                        }
                    }
                })
            });
        },

        setFieldUnvalid: function (field) {
            this.validationErrors.push(field);
            $(field).siblings('.front-field-validation-error').slideDown();
        },
        setFieldValid: function (field) {
            var index = this.validationErrors.indexOf(field);
            this.validationErrors.splice(index, 1);
            $(field).siblings('.front-field-validation-error').slideUp();
        }

    },
    'cms_page': {
      init: function () {
          jQuery(window).load(function () {
              if ($('#related').length) {
                  //$('#related .single-blog-post .post_thumb').equalHeights();
                  new Swiper('.blog-posts-swiper', {
                    navigation: {
                      nextEl: '.blogs-button-next',
                      prevEl: '.blogs-button-prev',
                    },
                      loop: false,
                      slidesPerView: 4,
                      loopAdditionalSlides: 0,
                      spaceBetween: 5,
                      on: {
                        transitionEnd: function () {
                          lazyInstance.update();
                        }
                      },
                      breakpoints: {
                          991: {
                              slidesPerView: 1
                          }
                      }
                  });
              }
          });
        var productSort = loadProductSort();
        productSort.init();
      }
    },
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        Sage.lazy_init();
        $('#more-info-tabs').find('a').click(function(){
          setTimeout( function(){lazyInstance.update();}, 500);
        });

        // If an anchor is used
        if (location.hash && $(location.hash).length) {
          $("html, body").animate({scrollTop : $(location.hash).offset().top - 20 - (window.innerWidth < 1100 ? $('.fixed-header').outerHeight() : $('.fixed-header').height())}, '500', 'swing');
        }

        if ($('.attributes-block .attribute-item').length) {
          // Fix for FF cache
          selectedVal = $('#attributes .product-attributes option[selected]').val();

          $('.attributes-block .attribute-item').click( function(e) {
            var dataValue = $(this).attr('data-value');
            $(this).closest('.attributes-block').find('.attribute-item').removeClass('active');
            $(this).addClass('active');
            if ($('.bogo-attribute-label').length) {
              $('.bogo-attribute-label').removeClass('active');
              $(this).prev('.bogo-attribute-label').addClass('active');
            }
            var group = $(this).closest('.attributes-block').data('group-id');
            $('#'+group).find('option').removeAttr('selected');
            $('#'+group).find('option').each(function(){
              if ($(this).val() == dataValue) {
                $(this).attr('selected', 'selected');
                $(this).parent().val(dataValue);
                $(this).parent().trigger('change');
              }
            });
          });
        }

        $('label[for="selectPrductSort"]').click(function (e) {
          e.preventDefault();
          e.stopPropagation();
          $(this).next('div').find('.dropdown-toggle').click();
        });

		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.addedNodes && mutation.addedNodes.length > 0) {
					// element added to DOM
					var hasClass = [].some.call(mutation.addedNodes, function(el) {
						return el.classList.contains('ekw128')
					});
					if (hasClass) {
						stickyMenu();
					}
				}
			});
		});

		var config = {
			attributes: true,
			childList: true,
			characterData: true
		};

    if ($('#widget-container-mobile').length > 0) {
      observer.observe(document.getElementById('widget-container-mobile'), config);
    }

		stickyMenu();
		$(window).resize(function() {
			stickyMenu();
		});
        $(window).on('scroll', function () {
		  stickyMenu();
          Sage.update_index_search($(this).scrollTop());
        });

        if ($('select#pagination_selectric').length) {
          $('select#pagination_selectric').selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            arrowButtonMarkup: '<span class="selectric_arrow"><i class="fa fa-angle-down"></i></span>',
            labelBuilder: function (currItem) {
              return '<span class="selectric_current">'+ currItem.text +'</span>';
            },
            onOpen: function() {
              $('.selectric-items').toggle();
            },
            onClose: function() {
              $('.selectric-items').toggle();
            },
          });
        }

        initSwiper = function (selector, space, obj) {
          var slidesPerView = $(selector).data('slides-per-view') ? $(selector).data('slides-per-view') : 3;
          return new Swiper(selector, {
            loop: false,
            slidesPerView: slidesPerView,
            loopAdditionalSlides: 0,
            spaceBetween: space,
            navigation: {
              nextEl: selector + ' .button-next',
              prevEl: selector + ' .button-prev'
            },
            preventClicksPropagation: false,
            preventClicks: false,
            speed: 1200,
            freeMode: true,

            setWrapperSize : obj.wrapperSize || false,
            roundLengths : obj.roundLen || false,
            centeredSlides : obj.centeredSlide || false,

            slidesOffsetBefore : window.innerWidth <= 480 ? 5 : 0,

            breakpoints: {
              991: {
                slidesPerView: 'auto',
                spaceBetween: space
              },
              1199: {
                slidesPerView: 3,
                spaceBetween: space
              }
            },

            on: {
              init: function () {
                /* We need to wait */
                /* Check for offset on first slide */
                var swiper = $(selector)[0].swiper;
                setTimeout( setFirstOffset(swiper.activeIndex,selector, obj), 5000);
              },
              transitionEnd: function () {
                lazyInstance.update();
              },
              afterResize: function() {
                /* Try reset to default values */
                resetSwiper(selector, obj);
              },
              slideChangeStart: function() {
                $(selector + ' .button-next,' + selector + ' .button-prev').addClass('busy');
              },
              slideChangeEnd: function() {
                $(selector + ' .button-next,' + selector + ' .button-prev').removeClass('busy');

                resetSwiper(selector, obj);

                /* No need more*/
                if(window.innerWidth > 480) return;

                /* Check for offset on first slide */
                setFirstOffset(swiper.activeIndex,selector, obj);

                var prev = $(selector +' .swiper-slide-prev') || false;
                if(prev) {
                  if(obj.padding) {
                    prev.css('padding-left', (obj.padding.left));
                    prev.css('padding-right', (obj.padding.right));
                  }
                  prev.css('margin-left', (obj.marginLeftPrev || '25%'));
                }
              }
            }
          });
        };

        var initSwipers = function() {
          if ($(".isotop-carousel").length) {
            var swipers = [];
            $('.isotop-carousel').each(function (i, e) {
              var id  = $(this).attr('id');
              var bank = $('#' + id).find('.bank');

              if (id !== 'homefeatured-carousel' || $(window).width() < 768) {
                swipers.push(initSwiper('#' + id + ' .swiper-container', 0, {}));
                $('#' + id).siblings('.products-filter-wrapper').find('.products-filter').on('click', function () {
                  $(this).addClass('selected').siblings('.products-filter').removeClass('selected');
                  if (!bank.find('.swiper-slide').length) {
                    bank.html($('#' + id + ' .swiper-wrapper').html());
                  }
                  var selector = $(this).attr('data-filter');
                  if ('*' == selector) {
                    selector = '.swiper-slide';
                  }
                  var slides = bank.clone().find(selector);
                  swipers[i].removeAllSlides();
                  swipers[i].appendSlide(slides);
                  swipers[i].update();
                  Sage.lazy_init();
                  $('#' + id + ' .swiper-container .button-prev,#' + id + ' .swiper-container .button-next').removeClass('busy');
                  $(window).trigger('resize');
                });
                if ($(window).width() < 1100) {
                  $('#' + id + ' .swiper-container').css('padding-bottom', $('#' + id + ' .swiper-pagination').height());
                }
                $(window).resize(function () {
                  if ($(window).width() < 1100) {
                    $('#' + id + ' .swiper-container').css('padding-bottom', $('#' + id + ' .swiper-pagination').height());
                  } else {
                    $('#' + id + ' .swiper-container').css('padding-bottom', 'inherit');
                  }
                });
              }
            });
          }
        }

		function stickyMenu() {
			if (!$('body').hasClass('checkout_step')) {
				if(window.innerWidth < 1100 && $(window).scrollTop() >= $('#widget-container-mobile').height()) {
				   $('.fixed-header').css('position', 'fixed');
				   $('#header').css('margin-bottom', $('.fixed-header').height());
			    }
			    else {
					if(window.innerWidth >= 1100) {
						$('.fixed-header').css('position', 'fixed');
						$('#header').css('margin-bottom', 164);
						$('#header.checkout_step').css('margin-bottom', 40);
					}
					else {
					   $('#header').css('margin-bottom', 0);
						$('.fixed-header').css('position', 'static');
					}
			    }
			}
		}

        function setFirstOffset( index, selector, obj ) {
          var windowWidth = window.innerWidth;

          if(index || windowWidth > 480) return;

          var amountOffset = windowWidth > 320 ? ( obj.firstOffset || '18%') : ( obj.firstOffset320 || '45px');
          $(selector +' .swiper-slide-active').css('margin-right', amountOffset);
        }

        function resetSwiper(selector, obj) {
            $(selector +' .swiper-slide').css('margin-left', obj.marginLeftDefault || '0');
            $(selector +' .swiper-slide').css('margin-right',obj.marginRightDefault || '0');
        }

        if ($(window).width() > 767 && $(window).width() < 1100) {
          $('#homefeatured-carousel').removeClass('isotop-carousel').addClass('no-carousel');
        }

        if ($('body').hasClass('product_page')) {
          Sage.lazyInitComponent($(".isotop-carousel"), initSwipers);
        }
        else {
          initSwipers();
        }


        //change product picture on swipe
        (function () {
          var startX = 0,
            startY = 0,
            movingX = 0,
            movingY = 0;
          $('#image-block').on('touchstart', function(e) {
            startX = e.originalEvent.changedTouches[0].pageX;
            startY = e.originalEvent.changedTouches[0].pageY;
          });

          $('#image-block').on('touchmove', function (e) {
            movingX = e.originalEvent.changedTouches[0].clientX - startX;
            movingY = e.originalEvent.changedTouches[0].clientY - startY;
          });

          $('#image-block').on('touchend', function (e) {
            if (movingX <= 0 && Math.abs(movingY) < 50) {
              updateProductImage('next');
            }
            if (movingX > 0 && Math.abs(movingY) < 50) {
              updateProductImage('prev');
            }
          });
        })();

        $('#productsSortForm .mobile-sort li').click(function () {
          if ("function" == typeof window.productSort) {
            window.productSort($(this).data('value'));
          }
        });

        function updateProductImage(direction)
        {
          var shown   = $('#thumbs_list').find('.thickbox.shown');
          if (screen_data.width_current >= md_width || !shown.length) {
            return;
          }
          var elements  = $('#thumbs_list').find('.product-thumbnail'),
            current   = shown.parent('.product-thumbnail'),
            original  = 'next' == direction ? current.next() : current.prev(),
            reserve   = 'next' == direction ? elements.first() : elements.last();

          if (original.length) {
            displayImage(original.find('.thickbox'));
          }
          else if (reserve.length) {
            displayImage(reserve.find('.thickbox'));
          }
        }

        $('body').on('click', '#search-icon:not(.doofinder-trigger)', function(event){
          event.preventDefault();
          var search_block  = $('.searchbox-top'),
            menu_block    = $('#tmcategories-mobile'),
            to_open     = !search_block.hasClass('open');
          search_block.toggleClass('open', to_open);
          menu_block.toggleClass('search-enabled', to_open);
          if (to_open) {
            $('input#search_query_top').focus();
          }
          return false;
        });




		$('body').click(function(e){
			const item = $(e.target).closest('#cat .with-subcat');
			if (item.length) {
				if ($(e.target).is('#cat .with-subcat > .item-link')) {
					e.preventDefault();
				}
				if (!item.find('.subcats-wrapper').is(':visible')) {
					$('#cat .with-subcat .subcats-wrapper').hide();
					$('#cat .with-subcat').removeClass('open')

					item.addClass('open');
					item.find('.subcats-wrapper').css('display', 'flex');
				}
				else {
					item.removeClass('open');
					item.find('.subcats-wrapper').hide();
				}
			}
			else {
				$('#cat .with-subcat .subcats-wrapper').hide();
				$('#cat .with-subcat').removeClass('open')
			}
		});

		$('.tmcategories-mobile .with-subcat > div > .item-link').on('click', function(e){
			e.preventDefault();
			$(this).parent().parent().toggleClass('open')
				.find('>.subcat').toggle();
		});

        $('body').on('click', '#searchbox button.search_button.doofinder-trigger', function(event){
          event.preventDefault();
          return false;
        });

        $('body').on('click', '#searchbox .fa-search', function(event){
          $('#searchbox').submit();
        });

        $('body').on('click', '#add-2-cart-mobile-close', function(event){
          event.preventDefault();
          $.fancybox.close();
        });

        $('body').on('click', 'a', function(event){
          if (!$(this).hasClass('noscroll')) {
            var currentHref = window.location.href.split('#');
            var href = $(this).attr('href');
            if (typeof href !== typeof undefined && href !== false) {
              href = href.split('#');
              if (
                (typeof popupTriggerElement_desktop !== 'undefined' && popupTriggerElement_desktop === href[1]) ||
                (typeof popupTriggerElement_mobile !== 'undefined' && popupTriggerElement_mobile === href[1])
              ) {
                event.preventDefault();
                return;
              }
              if ((href[0] == currentHref[0] || href[0] == '') && typeof (href[1]) != undefined) {
                if (href[1] === 'house-number-popup') {
                  return;
                }
                if ($('#' + href[1]).length != 0) {
                  $("html, body").animate({scrollTop: $('#' + href[1]).offset().top - 20 - (window.innerWidth < 1100 ? $('.fixed-header').outerHeight() : $('.fixed-header-index-wrapper').height())}, '500', 'swing');
                }
                if ($('a[name=' + href[1] + ']').length != 0) {
                  event.preventDefault();
                  $("html, body").animate({scrollTop: $('a[name=' + href[1] + ']').offset().top - 20 - (window.innerWidth < 1100 ? $('.fixed-header').outerHeight() : $('.fixed-header-index-wrapper').height())}, '500', 'swing');
                }
              }
            }
          }
        });

        $(window).resize(function () {
          $('.inline-menu-block-name-wrap').removeAttr('height').css({height: ''}).equalHeights();
          Sage.product_block_height();
          Sage.update_cart_height();
        });

        $('.icheck').not('.icheckbox_minimal-blue-custom .icheck').iCheck({
          checkboxClass: 'icheckbox_minimal-blue-custom',
          radioClass: 'iradio_minimal-blue-custom',
          increaseArea: '20%'
        });

        function initPopover(selector) {
          if ($(window).width() < 768) {
            $(selector+'Link').fu_popover({
              trigger: 'click',
              content: $(selector+'Content').html(),
              title: '',
              placement: 'bottom',
              width: '400px'
            });
            $(document).mouseup(function (e){
              var div = $(".fu_popover_content_default");
              if (!div.is(e.target)
                  && div.has(e.target).length === 0) {
                $(selector+'Link').fu_popover('hide');
              }
            });
          } else {
            $(selector+'Link').fu_popover({
              trigger: 'hover',
              content: $(selector+'Content').html(),
              title: '',
              placement: 'bottom',
              width: '400px'
            });
            $('body').on('mouseleave', '.fu_popover_default', function (e) {
              $(selector+'Link').fu_popover('hide');
            });
            $('body').on('mouseleave', '#authorLink, #reviewerLink', function (e) {
              var div = $('.fu_popover_content_default');
              var arrow = $('.arrow_top_default');
              if (!div.is(e.relatedTarget) && !arrow.is(e.relatedTarget))
                $(selector+'Link').fu_popover('hide');
            });
          }
        }

        if ($('#authorLink').length) {
          initPopover('#author');
        }

        if ($('#reviewerLink').length) {
          initPopover('#reviewer');
        }

        if ('ontouchstart' in window) {
          $("#reviewerLink, #authorLink").click(function (e) {
            e.preventDefault();
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        Sage.update_cart_height();

        if ($('body').hasClass('product_page')) {
          Sage.lazyInitComponent($('.products-container'), Sage.product_block_height);
        }
        else {
          Sage.product_block_height();
        }
      }
    },

  'prestablog_page': {
    init: function () {
      if($("ul.pagination li:last a").length && "function" == typeof(InfiniteScroll)) {
        var $blogListContainer = new InfiniteScroll('#product_list', {
          navSelector: "div.pagination",
          nextSelector: "ul.pagination li:last a",
          append: "#product_list .blog_post",
          status: ".hidden-light",
          loadOnScroll: false,
          path: function () {
            var pagination_str = $("ul.pagination li:last a").attr('href').match(/p=\d*/)[0].split('=');
            var pageNmb = parseInt(pagination_str[1]);
            var listeParPage = $("ul.pagination li:last a").data('nb-per-page');
            var nextPage = (pageNmb + ($(".post_list .blog_post_item").length-listeParPage)/listeParPage);

            var possible_loads = nb_pages - (pageNmb - 1);

            if (this.loadCount === possible_loads) {
              $('.view-more-button').remove();
            }
            $('.hidden-light').hide();

            if ($("ul.pagination li:last a").length) {
              return $("ul.pagination li:last a").attr('href').replace(/p=\d*/, "p=" + Math.floor(nextPage));
            }
          }
        });

        $('#product_list').on( 'append.infiniteScroll', function( response ) {
          if (typeof(FB) !== 'undefined') {
            FB.XFBML.parse(); //facebook comments counters
          }
        });
      }

      $('.view-more-button').on( 'click', function(e) {
        e.preventDefault();
        $blogListContainer.loadNextPage();
        $('.hidden-light').show();
      });

      jQuery(window).load(function () {
        if ($('#related').length) {

            var selector = '#blogs_list .swiper-container';
            var space = 0;
            var slidesPerView = 4;

            new Swiper(selector, {
                loop: false,
                slidesPerView: slidesPerView,
                loopAdditionalSlides: 0,
                spaceBetween: space,
                navigation: {
                  nextEl: selector + ' .button-next',
                  prevEl: selector + ' .button-prev'
                },
                preventClicksPropagation: false,
                preventClicks: false,
                speed: 1200,
                roundLengths: true,
                freeMode : true,

                on: {
                  transitionEnd: function () {
                    lazyInstance.update();
                  }
                },
                breakpoints: {
                    480: {
                        slidesPerView: 'auto',
                        spaceBetween: space
                    },
                    767: {
                        slidesPerView: 'auto',
                        spaceBetween: space
                    },
                    1199: {
                        slidesPerView: 4,
                        spaceBetween: space
                    }
                }
            });
        }
      });
    }
  },

  'category_page': {
    init: function() {
      Sage.update_wishlist_buttons();

      if (window.innerWidth > 1100 && $('body').hasClass('category_page')) {
        setProductListInfiniteScroll();
      }

      var productSort = loadProductSort();
      productSort.init();
      showPopover();
    }
  },

  'new_products_page': {
    init: function() {
      Sage.update_wishlist_buttons();

      if (window.innerWidth > 1100 && $('body').hasClass('new-products_page')) {
        setProductListInfiniteScroll();
      }

      var productSort = loadProductSort();
      productSort.init();
      showPopover();
    }
  },

  'contact_form_page': {
    init: function() {
      $('#common_questions').on('change', function() {
        $('.answer').hide();
        $('#answer_'+$(this).val()).slideDown();
      });
      $('.answer').hide();
      $('#answer_'+$('#common_questions').val()).slideDown();
      $('.category-icon a').on('click', function(e) {
        $('#common_questions').val(0);
        $('.category-icon a').removeClass('active');
        $(this).addClass('active');
        $('.category, .answer').hide();
        $('#category_'+$(this).data('id')).slideDown();
        $("html, body").animate({
          scrollTop : $('#category_'+$(this).data('id')).offset().top - (window.innerWidth < 1100 ? $('.fixed-header').outerHeight() : $('.fixed-header').height())
        }, '500', 'swing');
      });
      $('.category .question').on('click', function(e) {
        var parent = $(this).parent().parent();
        if (parent.hasClass('active')) {
          parent.removeClass('active');
          $(this).parent().next().slideUp();
        }
        else {
          parent.addClass('active');
          $(this).parent().next().slideDown();
        }
      });

      // 'faqpage' module code - START
      var link = window.location.hash.substr(1);
      if (link) {
        //fix chrome automatic scroll
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        var categoriesIcons = $('.category-icon a');
        var questions = $('.category .question');

        categoriesIcons.each(function(i) {
          if (link == $(this).data('link')) {
            $(this).click();
          }
        });

        questions.each(function(i) {
          if (link == $(this).data('link')) {
            var question = $(this);
            var category = question.closest('.category');
            var categoryIcon = categoriesIcons.filter('*[data-id='+ category.data('id') + ']');

            categoryIcon.addClass('active');
            $('#category_' + categoryIcon.data('id')).slideDown(200, function () {
              $('html, body').animate({
                scrollTop : question.offset().top - 15 - (window.innerWidth < 1100 ? $('.fixed-header').outerHeight() : $('.fixed-header').height())
              }, '300', 'swing');
              question.click();
            });
          }
        });
      }
    }
    // 'faqpage' module code - END
  },
  'best_sales_page': {
    init: function() {
      var productSort = loadProductSort();
      productSort.init();
    }
  },
  'bitcoinhd_payment_page': {
	  init: function() {
          if ($('#bitcoin-api-params').data('params-idorder')) {
            setTimeout(function () {
              $('#bitcoin-payment').trigger('click');
            }, 200);
          }

		  $(document).on('click', '#QRCodeBtn', function(){
			  $('#bitcoin-payment-modal .total').slideToggle();
			  $('#bitcoin-payment-modal .crypto-text').slideToggle();
			  $('#bitcoin-payment-modal .qrcode-wrapper').slideToggle();
			  $('#bitcoin-payment-modal .show_qr, #bitcoin-payment-modal .hide_qr').toggle();
		  });

		  $(document).on('click', '#bitcoin-payment-modal .copy', function(e){
			  e.preventDefault();
			  var $input = $('#'+$(this).attr('for'));
			  var str = $input.val();
			  if ($input.is('#total_btc')) {
                str = str.split(' ')[0];
              }
              copyStringToClipboard(str);
		  });

		  $(document).on('modal-open', function(){
				var timer = $('.countdown .timer');
				var date = new Date();
				var expire = date.setSeconds(date.getSeconds() + Number(timer.data('timeout')));

				var countdown = setInterval(function() {
					var now = new Date().getTime();
					var distance = expire - now;
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60));
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);

					if (distance <= 0) {
						clearInterval(countdown);
						return;
					}
					timer.text((hours ? hours + "hours " : "") + minutes + "min " + seconds + "s ");

				}, 1000);
		  });
	  }
  }
  };

  function setProductListInfiniteScroll() {
    $('#pagination').hide();

    if (!($('#pagination_next').length) || $('#pagination_next').hasClass('disabled') || "undefined" == typeof(InfiniteScroll)) {
      return;
    }
    var pathBlock = $('ul.pagination li:last a');
    productListContainer = new InfiniteScroll('#product_list', {
      navSelector  : '#pagination',
      nextSelector : 'ul.pagination li:last a',
      itemSelector : '.products-container .ajax_block_product',
      append: '#product_list .ajax_block_product',
      checkLastPage: true,
      path: function() {
        $('.hidden-light').show();
        var path = '';
        if ($('.products-container .ajax_block_product').length + ((products_on_page * page_number) - products_on_page) < nb_products && pathBlock.length) {
          path = pathBlock.attr('href').replace(/p=\d*/, "p="+(page_number + this.pageIndex));
          if (typeof(AtdProductFilter) !== 'undefined' && !AtdProductFilter.firstList && $('#product-info-control').hasClass('show')) {
            path += '&hidefeatures=1';
          }
        } else {
          $('.hidden-light').hide();
        }
        if ('undefined' != typeof (dataLayer)) {
          dataLayer.push({'event': 'optimize.activate'});
        }
        return path;
      }
    });
    productListContainer.on('append', function() {
      Sage.lazy_init();
      $('#product_list').find('.atdevshowattribute select').each(function () {
        var attr = $(this).parent().parent().find('a').data('product-attribute');
        $(this).children('option[value='+attr+']')[0].selected = true;
      });
      if (!$('#product-info-control').hasClass('show')) {
        $('.atd-filter-feature-prop-container').show();
      }
      else {
        $('.atd-filter-feature-prop-container').hide();
      }
      Sage.product_block_height();
      Sage.update_wishlist_buttons();
      if (typeof AtdProductFilter !== 'undefined') {
        AtdProductFilter.firstList = false;
      }
      if (typeof pushImpressions === 'function' && typeof impressionsListing !== 'undefined') {

        var allProducts = $('.ajax_add_to_cart_button');
        var newProducts = allProducts.splice((this.pageIndex-1)*products_on_page);

        $(newProducts).each(function () {
          var data_element = $(this);
          var data_impressions = {
            'id': $(data_element).data('ga-id'),
            'name': $(data_element).data('ga-name'),
            'variant': $(data_element).data('ga-variant'),
            'category': $(data_element).data('ga-category'),
            'brand': $(data_element).data('ga-brand'),
            'list': $(data_element).data('ga-list'),
            'position': $(data_element).data('ga-position')
          };

          if ($(data_element).data('ga-reduction')) {
            data_impressions.dimension4 = "yes";
            data_impressions.metric1 = $(data_element).data('ga-reduction').toFixed(2);
          }

          impressionsListing.push(data_impressions);
        });

        pushImpressions(impressionsListing);

        var $containers = $('.atd-filter-feature-prop-container');
        if ($containers.length) {
          var maxHeight = 0;
          $containers.each(function (index, element) {
            var h_block = parseInt($(element).outerHeight(true));
            if (h_block > maxHeight) {
              maxHeight = h_block;
            }
          });
          $containers.css('height', maxHeight);
        }

      }
    });
    productListContainer.on('history', function (title, path) {
      history.pushState({}, null, path.replace(/&hidefeatures=\d*/, ""));
    });
  }

  function updateProductListContainerHeight () {
    Sage.product_block_height();
    $('.products-container').each(function (i, elem) {
      var product_content_block = $(this).find('.ajax-block-product-content:visible');
      if (product_content_block) {
        product_content_block.css('min-height', 'initial');
        product_content_block.css('height', 'auto');
        setTimeout(function () {
          var originalHeight = product_content_block.height();
          $(elem).find('.ajax-block-product-content:visible').each(function (index, element) {
            var h_block = parseInt($(element).height());
            if(h_block > originalHeight) {
              originalHeight = h_block;
            }
          });
          product_content_block.height(originalHeight + $(this).find('.prices-block:visible').height());
          $('#product_list').find('.ajax-block-product-content:visible').height(originalHeight+ $(this).find('.prices-block:visible').height());
        }, 50);
      }
    });

    var $containers = $('.atd-filter-feature-prop-container');
    if ($containers.length) {
      var maxHeight = 0;
      $containers.each(function (index, element) {
        var h_block = parseInt($(element).outerHeight(true));
        if (h_block > maxHeight) {
          maxHeight = h_block;
        }
      });
      $containers.css('height', maxHeight);
    }

    $('.inline-menu-block-name-wrap').removeAttr('height').css({height: ''}).equalHeights();
  }

  function loadProductSort() {
    var productSort = {
      $mobileSort: null,
      mobileSortingInitialized: false,
      init: function () {
        var self = this;
        this.$mobileSort = $('#sort-mobile');
        // close mobile modal dialog
        $('.atd-filter-container-mobile').find('.close-btn').on('click', function (e) {
          e.preventDefault();
          $('html, body').removeClass('no-scroll');
          $(document).scrollTop(document.scrollTop);
          self.$mobileSort.hide();
        });
        $(window).on('change', '#selectFilterSort, #selectPrductSort, input[name=product-sort-mobile]', function (e) {
          e.stopImmediatePropagation();
          if ($(e.target).is('input[name=product-sort-mobile]')) {
            self.$mobileSort.hide();
            $('html, body').removeClass('no-scroll');
            $(document).scrollTop(document.scrollTop);
          }
          self.actionSort($(this).val());
        });

        this.initSorting();
      },
      initSorting: function () {
        var self = this;

        var $select = $('select#selectFilterSort');
        if (!$select.length) {
          $select = $('select#selectPrductSort');
        }
        if (typeof $select.selectric === 'function') {
          $select.selectric({
            arrowButtonMarkup: '<span class="button"></span>',
            labelBuilder: function (currItem) {
              return '<span>' + $select.closest('#productsSortForm').find('label').text() + '</span> ' + currItem.text;
            }
          });
        }
        $('#product-info-control').on('click', function (e) {
          e.preventDefault();
          $(this).toggleClass('show');
          $('.atd-filter-feature-prop-container').toggle();
          updateProductListContainerHeight();
        });

        $('#atd-sort-trigger-mobile').on('click', function (e) {
          if (!self.mobileSortingInitialized) {
            self.initMobileSorting();
          }
          document.scrollTop = $(document).scrollTop();
          $('html, body').addClass('no-scroll');
          self.$mobileSort.show();
        });
      },

      initMobileSorting: function () {
        var $list = this.$mobileSort.find('.body .sort-options-wrap');
        $list.html('');
        var $options = $('#selectFilterSort option');
        if (!$options.length) {
          $options = $('#selectPrductSort option');
        }
        $options.each(function (i) {
          var checkedAttr = this.selected ? 'checked' : '';
          var $input = $('<input id="sort_'+i+'" name="product-sort-mobile" type="radio" value="'+$(this).val()+'" '+checkedAttr+'>');
          var $label = $('<label for="sort_'+i+'">'+$(this).text()+'</label>');
          var $option = $('<div class="radio">').append($input).append($label);
          $list.append($option);
        });
        this.mobileSortingInitialized = true;
      },

      actionSort: function(orderby) {
        var splitData = orderby.split(':');
        var requestData = '';
        if (splitData[0] == 1*splitData[0]) {
          requestData = 'featureby=' + splitData[0] + '&featureway=' + splitData[1];
        } else {
          requestData = 'orderby=' + splitData[0] + '&orderway=' + splitData[1];
        }
        if (typeof(AtdProductFilter) !== 'undefined' && !AtdProductFilter.firstList && $('#product-info-control').hasClass('show')) {
          requestData += '&hidefeatures=1';
        }
        requestData +='&ajax_sort=1';
        $('body').addClass('loading-light');
        $.ajax({
          type: 'GET',
          url: $('#productsSortForm').attr('action'),
          async: true,
          data: requestData,
          success: function(response)
          {

            if ($('.productListAccessoryTop').length) {
              if (typeof(AtdProductFilter) !== "undefined") {
                AtdProductFilter.$mobileFilter = $('#atd-filter-mobile');
                AtdProductFilter.isMobileFilter = false;
              }
            }
            if ($('.product-list-top-block').length) {
              $('.product-list-top-block').html($(response).find('.product-list-top-block').html());
            }
            $('#product_list').html($(response).find('#product_list').html());
            if ($(response).find('#pagination_next').length && !$(response).find('#pagination_next').hasClass('disabled')) {
              $('#pagination').html($(response).find('#pagination').html());
            }
            $('#product_list').trigger('filter-after');
            $('.category-nav.new-products li.active span').trigger('click');
            $('body').removeClass('loading-light');

            if (typeof(AtdProductFilter) !== "undefined") {
              AtdProductFilter.updateProductListFeatures();
            }

            var scroll_value;
            if ($(window).width() < 1100) {
              scroll_value = 0;
            } else {
              scroll_value = 125;
            }
            $('html, body').animate({
              scrollTop: $('.productListAccessoryTop').offset().top - scroll_value
            }, 1000);
          }
        });
      }
    };

    $('#product_list').on('filter-after', function(){
      productSort.mobileSortingInitialized = false;
      productSort.init();
      if (typeof(productListContainer) !== "undefined") {
        productListContainer.destroy();
      }
      $('.hidden-light').hide();
      if ($('body').hasClass('category_page')) {
        setProductListInfiniteScroll();
      }
      Sage.lazy_init();
    });

    return productSort;
  }

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
  fire: function(func, funcname, args) {
    var fire;
    var namespace = Sage;
    funcname = (funcname === undefined) ? 'init' : funcname;
    fire = func !== '';
    fire = fire && namespace[func];
    fire = fire && typeof namespace[func][funcname] === 'function';

    if (fire) {
    namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    // Fire common init JS
    UTIL.fire('common');

    // Fire page-specific init JS, and then finalize JS
    $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
    UTIL.fire(classnm);
    UTIL.fire(classnm, 'finalize');
    });

    // Fire common finalize JS
    UTIL.fire('common', 'finalize');
  }
  };

  window.UTIL = UTIL;
  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

jQuery.fn.equalHeights = function () {
  var maxHeight = 0,
      self      = jQuery(this);

  self.each(function () {
    var height = jQuery(this).innerHeight();

    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  return self.css('height', maxHeight);
};


function showPopover () {
  if($(window).width() < 768) {
    $('.popover-tooltip').data("placement", "bottom");
    $('.popover-tooltip').popover({
      trigger: 'focus'
    });
  }
  else {
    $('.popover-tooltip').popover({
      trigger: 'hover'
    });
  }
  if(typeof first_time_user != 'undefined' && first_time_user) {
    $('.popover-tooltip').popover('show');
  }
}

$(document).mouseup(function (e) {
  var container = $('.popover-tooltip');
  if (container.has(e.target).length === 0 && $('#closeAgePopup').has(e.target).length === 0 && $('.popover-content').length && typeof first_time_user !== 'undefined' && first_time_user){
    $('.popover-tooltip').popover('hide');
  }
});
